const MONTH_ABBR = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

/**
 * Formats any date value to dd-MMM-yyyy (e.g. 25-MAY-2026).
 * Handles ISO date-only strings, ISO datetime strings, and already-formatted values.
 * Returns '' for null/undefined.
 */
export const formatDate = (val) => {
  if (!val) return '';
  if (/^\d{2}-[A-Za-z]{3}-\d{4}$/.test(val)) return val.toUpperCase();
  const d = new Date(val);
  if (isNaN(d.getTime())) return String(val);
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(val));
  const day = String(isDateOnly ? d.getUTCDate() : d.getDate()).padStart(2, '0');
  const mon = MONTH_ABBR[isDateOnly ? d.getUTCMonth() : d.getMonth()];
  const yr  = isDateOnly ? d.getUTCFullYear() : d.getFullYear();
  return `${day}-${mon}-${yr}`;
};

/**
 * Formats a date+time value to a "date" + "time" pair for timeline display.
 * Returns { date: 'dd-MMM-yyyy', time: 'HH:mm:ss' }.
 */
export const formatDateTime = (val) => {
  if (!val) return { date: '', time: '' };
  const d = new Date(val);
  if (isNaN(d.getTime())) return { date: String(val), time: '' };
  const date = formatDate(val);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return { date, time: `${hh}:${mm}:${ss}` };
};
